export { getStaticProps } from './home-page/home-page-cms.server';

import HomePage from './home-page/home-page-cms';

export default HomePage;
